import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import {
  fetchMaintenance,
  fetchMaintenanceCSV
} from 'src/services/napi/maintenance/fetchMaintenanceData';

const fetchMaintenanceData = async (params: {
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  search?: string;
}) => {
  const { orderBy, orderDirection, page, pageSize, search } = params;
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await fetchMaintenance({
    orderBy: orderBy || 'updatedAt',
    orderDirection: orderDirection || '-1',
    page: page || '1',
    pageSize: pageSize || '10',
    projectId: currentProject._id,
    search: search || ''
  });
  return data;
};

export const fetchMaintenanceCSVData = async () => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await fetchMaintenanceCSV({
    projectId: currentProject._id
  });
  return data;
};

export const useGetMaintenance = (params: {
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  search?: string;
}) => {
  const { notify } = useNotification();
  const { orderBy, orderDirection, page, pageSize, search } = params;

  return useQuery(
    [QueryKey.MAINTENANCE, page, pageSize, orderBy, orderDirection],
    () =>
      fetchMaintenanceData({
        orderBy,
        orderDirection,
        page,
        pageSize,
        search
      }),
    {
      keepPreviousData: true,
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      }
    }
  );
};
